import type { SessionSummary } from '@league/shared/contract';
import type { StatusMeaning } from '@league/shared/status';

/*
  ⚠ WORKED OUT FROM WHAT HAPPENED — owner, 2026-10-04. These chips used to read `sessions.status`,
  which nothing in the product ever moves past `open`, so a session that had been played, scored and
  closed still said "Not started". Every session chip comes from here instead.
*/

/** Where a session's scores stand. */
export function scoreState(session: SessionSummary, now = new Date()): StatusMeaning {
  if (session.scoresApproved) return { label: 'Scores approved', tone: 'positive' };
  if (session.scoresClosedAt) return { label: 'Scores done', tone: 'positive' };
  if (session.scoresEntered > 0) return { label: 'Scores in progress', tone: 'neutral' };
  if (new Date(session.startsAt) > now) return { label: 'Upcoming', tone: 'neutral' };
  return { label: 'Needs scores', tone: 'accent' };
}

/** Where a session's seating stands. */
export function seatingState(session: SessionSummary): StatusMeaning {
  if (session.seating === 'published') return { label: 'Finalized', tone: 'positive' };
  if (session.seating === 'saved') return { label: 'Draft', tone: 'neutral' };
  return { label: 'Not arranged', tone: 'neutral' };
}
